<template>
  <div class="google-button-wrapper">
    <button class="google-button social-button" @click="submit">
      <img src="@/assets/images/SignIn/google.svg" alt="Google" />
    </button>
  </div>
</template>

<script>
import './styles.scss'

export default {
  name: 'GoogleButton',

  data() {
    return {
      CLIENT_ID: '521767325582-bntfr4tqabf2gndd4sjlqlktf6q5mu17.apps.googleusercontent.com'
    }
  },
  mounted() {
    this.loadGoogleSDK()
  },

  methods: {
    loadGoogleSDK() {
      // Проверяем, не загружен ли уже SDK
      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      document.body.appendChild(script)
    },

    async loginViaGoogle(code) {
      const response = await fetch('https://users.backend-pier.com/api/v1/user/login-google', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code })
      })

      const data = await response.json()

      if (data.auth_token && data.data) {
        this.$store.dispatch('signIn', data)

        // Устанавливаем валюту и язык из ответа бэкенда
        if (data.data.currency) {
          this.$store.commit('setCurrency', data.data.currency.toLowerCase())
        }
        if (data.data.language) {
          this.$store.commit('setLanguage', data.data.language.toLowerCase())
        }

        if (this.$analytics) {
          this.$analytics.send('login', {
            type: 'login',
            method: 'google',
            user_id: data.data?.user_id
          })
          this.$analytics.setUser(data.data?.user_id)
        }

        // Эмитим событие успешной авторизации родительскому компоненту
        this.$emit('auth-success', data)
      } else {
        console.error('Google auth failed:', data)
      }
    },

    submit() {
      if (!window.google) {
        return
      }

      window.google.accounts.oauth2
        .initCodeClient({
          client_id: this.CLIENT_ID,
          scope: 'openid email profile',
          callback: response => {
            if (response.code) {
              this.loginViaGoogle(response.code)
            }
          }
        })
        .requestCode()
    }
  }
}
</script>
